import React from "react";
import "../FiveGridChart/FiveGridChart.css";
import CompanyNameChart from "../../charts/CompanyNameChart/CompanyNameChart";
import GeographyChart from "../../charts/GeographyChart/GeographyChart";
import GroupBarChart from "../../charts/GroupBarChart/GroupBarChart";
import HorizontalBarChart from "../../charts/HorizontalBarChart/HorizontalBarChart";
import LineChart from "../../charts/LineChart/LineChart";

const FiveGridChart = () => {
  return (
    <div className="main">
    <div className="five-grid-container-row-one">
        <CompanyNameChart />
        <HorizontalBarChart/>
        <GroupBarChart />
    </div>
    <div className="five-grid-container-row-two">
        <GeographyChart />
        <LineChart/>
    </div>
    </div>
  );
};

export default FiveGridChart;
